import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './Maincontent'
const CurrencyExchangeDetailsList = () => {
  return (
     <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>

      <Helmet>
				<title>Currency Exchange Details List</title>
			</Helmet>
    <Header />
    <MainContent />
    </div>
  )
}
export default CurrencyExchangeDetailsList